export enum ChangeRequestStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  REVIEWED = 'REVIEWED',
  AGENCY_APPROVED = 'AGENCY_APPROVED',
  CLIENT_APPROVED = 'CLIENT_APPROVED',
  MERGED_CLOSED = 'MERGED_CLOSED',
  UNMERGED_CLOSED = 'UNMERGED_CLOSED',
}

export type ChangeRequestStatusCode =
  | 'DRAFT'
  | 'SUBMITTED'
  | 'REVIEWED'
  | 'AGENCY_APPROVED'
  | 'CLIENT_APPROVED'
  | 'MERGED_CLOSED'
  | 'UNMERGED_CLOSED'

export type ChangeRequestStatusName = Record<ChangeRequestStatusCode, string>

export const changeRequestStatuses: ChangeRequestStatusName = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  REVIEWED: 'REVIEWED',
  AGENCY_APPROVED: 'AGENCY_APPROVED',
  CLIENT_APPROVED: 'CLIENT_APPROVED',
  MERGED_CLOSED: 'MERGED_CLOSED',
  UNMERGED_CLOSED: 'UNMERGED_CLOSED',
}

export const changeRequestStatusLabels: ChangeRequestStatusName = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
  REVIEWED: 'Reviewed',
  AGENCY_APPROVED: 'Agency Approved',
  CLIENT_APPROVED: 'Client Approved',
  MERGED_CLOSED: 'Merged Closed',
  UNMERGED_CLOSED: 'Unmerged Closed',
}
